import { findFirst } from 'fp-ts/Array'
import { type Option, chain, fromNullable, map } from 'fp-ts/Option'
import { pipe } from 'fp-ts/function'
import { type State, _states } from './states'

export const findStateByAbbreviation = (abbreviation?: string): Option<State> =>
  pipe(
    fromNullable(abbreviation),
    chain(abbr =>
      pipe(
        [..._states],
        findFirst(state => state.abbreviation === abbr)
      )
    )
  )

export const abbreviationToName = (abbreviation?: string): Option<string> =>
  pipe(
    fromNullable(abbreviation),
    chain(findStateByAbbreviation),
    map(state => state.name)
  )
